import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('rol', res.data.rol);
      localStorage.setItem('nume', res.data.nume || res.data.email);
      onLogin(res.data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Autentificare esuata');
    } finally {
      setLoading(false);
    }
  }

  async function loginDemo() {
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', {
        email: 'demo@stocuri.softconsult.ro',
        password: 'demo1234'
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('rol', res.data.rol);
      localStorage.setItem('nume', res.data.nume || res.data.email);
      onLogin(res.data);
      navigate('/');
    } catch (err) {
      setError('Contul demo nu este disponibil momentan');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <h1>Gestiune Stocuri</h1>
        <p className="subtitle">Autentificare cu email si parola</p>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-msg">{error}</div>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            placeholder="Parola"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Se autentifica...' : 'Autentificare'}
          </button>
        </form>
        <button type="button" className="btn-demo" onClick={loginDemo} disabled={loading}>
          🎯 Intra Demo
        </button>
      </div>
    </div>
  );
}
